import { createContext } from "react";
export var RequiredAction;

(function (RequiredAction) {
  RequiredAction["REJECTED"] = "REJECTED";
  RequiredAction["GIVE_PEER_REVIEW"] = "GIVE_PEER_REVIEW";
  RequiredAction["PENDING_PEER_REVIEW"] = "PENDING_PEER_REVIEW";
})(RequiredAction || (RequiredAction = {}));

export var CourseStatusProviderContext = createContext({});
export var CourseProgressProviderContext = createContext({});